import React, { useEffect, useState } from 'react';
import { GoogleConsentCookieBanner } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';

import './style.scss';

const COOKIE_POLICY_PATH = '/privacy-verklaring-de-regenboog-groep';

const Cookie = () => {
  const { t } = useTranslation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!ready) {
    return null;
  }

  return (
    <GoogleConsentCookieBanner
      title=""
      manualButtonClassname="Button icon-after icon-arrow icon-variant-3"
      manualHeader={t('cookies.manualHeader')}
      cookieContentsShowMore={<div>{t('cookies.showDetails')}</div>}
      cookieContentsShowLess={<div>{t('cookies.hideDetails')}</div>}
      showAcceptOnlyNeeded
      necessaryButtonInverted={false}
      defaultValues={{
        necessary: true,
        preferences: false,
        statistics: false,
        marketing: false,
      }}
    >
      <h4>{t('cookies.title')}</h4>
      <p>
        {t('cookies.text')}
        <a href={COOKIE_POLICY_PATH}> {t('cookies.readMore')}</a>
      </p>
    </GoogleConsentCookieBanner>
  );
};

export default Cookie;
